import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Portfolio } from '../../../core/models';
type Nullable<T> = T | null;

@Component({
  selector: 'app-company-portfolio-btn',
  templateUrl: './company-portfolio-btn.component.html',
  styleUrls: ['./company-portfolio-btn.component.scss'],
})
export class CompanyPortfolioBtnComponent {
  @Input() portfolio: Nullable<Portfolio>;
  @Output() portfolioToggle = new EventEmitter<Nullable<Portfolio>>();
  toggleToPortfolio(portfolio: Nullable<Portfolio>) {
    this.portfolioToggle.next(portfolio);
  }
}
